import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Dropdown from '../../components/Dropdown';
import Icon from '../../components/Icon';
import LanguageSwitcher from '../LanguageSwitcher';
import './styles.css';
import { openWindow, locationAssign, isLanguageSwitcher } from '../../utils';
import CustomDropdown from '../../components/CustomDropdown';

const messages = defineMessages({
  helpDropdown: {
    id: 'help.dropdown',
    defaultMessage: 'Help Dropdown',
  },
  support: {
    id: 'help.support',
    defaultMessage: 'Contact Support',
  },
});

const contactSupportKey = 'help-nav-menu-contact-support';
const helpCenterKey = 'help-nav-menu-help-link';
const languageSwitcherKey = 'help-nav-menu-language-switcher';

export class HelpNavMenu extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    viewer: PropTypes.object,
    contactSupportEmail: PropTypes.string.isRequired,
  };

  state = {
    selectedValue: null,
    shouldMoveFocus: false,
    eventType: '',
  };

  helpLinkNavOptions = [
    {
      key: helpCenterKey,
      text: (
        <li tabIndex="0" aria-label="Help Center">
          Help Center
        </li>
      ),
      value: helpCenterKey,
    },
    {
      key: contactSupportKey,
      text: (
        <li tabIndex="0" aria-label="Contact Support">
          Contact Support
        </li>
      ),
      value: contactSupportKey,
    },
  ];

  componentDidMount() {
    document.addEventListener('keydown', this.keyDownHandler);

    if (isLanguageSwitcher()) {
      this.helpLinkNavOptions.push({
        key: languageSwitcherKey,
        text: 'Language Switcher',
        value: languageSwitcherKey,
        content: (
          <li tabIndex="0" aria-label="Language">
            <Dropdown.Item as={LanguageSwitcher} />
          </li>
        ),
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyDownHandler);
  }

  keyDownHandler = (e) => {
    const { open, selectedIndex } = this.customDropdownRef.state;
    // tab key
    if (e.keyCode === 9) {
      this.setState({ shouldMoveFocus: true });
    }
    // tab + shift key
    if (e.keyCode === 9 && e.shiftKey) {
      this.setState({ shouldMoveFocus: false });
    }
    if (open && selectedIndex !== -1) {
      if (e.keyCode === 40 || e.keyCode === 38) {
        this.setState({ eventType: 'keyboard' });
        document
          .querySelector(
            `#helpNav-dropdown .visible div:nth-child(${selectedIndex + 1}) li`,
          )
          .focus();
      }
    }
  };

  onBlurDropdown = (e, f) => {
    e.preventDefault();
    if (this.state.shouldMoveFocus) {
      document.querySelector('#notificationsNav').focus();
      this.setState({
        shouldMoveFocus: false,
      });
    }
  };

  setEventType = (value) => {
    this.setState({ eventType: value });
  };

  handleHelpLink = () => {
    openWindow('https://docs.powerschool.com/INTHC', { target: '_blank' });
  };

  handleContactSupport = () => {
    const { contactSupportEmail } = this.props;
    locationAssign(contactSupportEmail);
  };

  onDropDownChange = (e, { value }) => {
    switch (value) {
      case helpCenterKey:
        this.handleHelpLink();
        break;
      case contactSupportKey:
        this.handleContactSupport();
        break;
    }
    // to clear selection of dropdown, for keyboard accessibility
    this.setState({
      selectedValue: null,
    });
  };

  render() {
    const { intl, viewer } = this.props;
    const { selectedValue } = this.state;

    if (get(viewer, 'isAuthenticated')) {
      return (
        <CustomDropdown
          aria-label={intl.formatMessage(messages.helpDropdown)}
          selectOnBlur={false}
          selectOnNavigation={false}
          value={selectedValue}
          onBlur={this.onBlurDropdown}
          onChange={this.onDropDownChange}
          styleName="helpDropdown"
          id="helpNav-dropdown"
          onOpen={() => this.customDropdownRef.setState({ selectedIndex: -1 })}
          eventType={this.state.eventType}
          setEventType={this.setEventType}
          ref={(ref) => {
            this.customDropdownRef = ref;
          }}
          tabIndex="0"
          className="top right hidden-mobile"
          floating
          icon={null}
          trigger={<Icon name="help circle" size="huge" styleName="helpIcon" />}
          options={this.helpLinkNavOptions}
        />
      );
    } else return null;
  }
}

const mapStateToProps = (state) => ({
  viewer: get(state, 'current.viewer'),
});

export const HelpNavMenuContainer = connect(mapStateToProps)(
  injectIntl(HelpNavMenu),
);
export default HelpNavMenuContainer;
